<template>
    <b-badge v-if="statusInfo" :variant="statusInfo.variant">
        {{ statusInfo.text }}
    </b-badge>
    <span v-else>-</span>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    components: {
        BBadge,
    },
    props: {
        row: Object,
        field: Number,
    },
    data() {
        return {
            statusMap: {
                0: { text: "Ödendi", variant: "light-success" },
                1: { text: "Ödenmedi", variant: "light-secondary" },
                2: { text: "Fazla Ödendi", variant: "light-info" },
                3: { text: "Eksik Ödendi", variant: "light-danger" },
            },
        };
    },
    computed: {
        statusInfo() {
            return this.field != null ? this.statusMap[this.field] : null;
        },
    },
};
</script>
